import { gql } from '@apollo/client';

export const GET_PRODUCTS = gql`
  query GetProducts($projectId: ID!) {
    products(projectId: $projectId) {
      id
      projectId
      title
      sku
      description
      unitOfMeasure
      productCategory
      isActive
      updatedAt
      components {
        id
      }
    }
  }
`;

export const GET_PRODUCT = gql`
  query GetProduct($id: ID!, $projectId: ID!) {
    product(id: $id, projectId: $projectId) {
      id
      projectId
      title
      sku
      description
      unitOfMeasure
      productCategory
      isActive
      updatedAt
      components {
        id
        parentProductId
        childProductId
        quantity
        unitOfMeasure
        position
        notes
        child {
          id
          title
          sku
          unitOfMeasure
          productCategory
          isActive
        }
      }
    }
  }
`;
